import axios from "axios";

export class GoogleHealthScopeError extends Error {
  readonly details?: unknown;

  constructor(message: string, details?: unknown) {
    super(message);
    this.name = "GoogleHealthScopeError";
    this.details = details;
  }
}

export const GOOGLE_HEALTH_SCOPE_RECONNECT_MESSAGE =
  "Permissões do Google Health insuficientes. Desconecte e conecte novamente sua conta Google Health no perfil para autorizar os novos acessos.";

function getErrorPayload(error: unknown): Record<string, unknown> | undefined {
  if (!axios.isAxiosError(error)) return undefined;
  const data = error.response?.data;
  if (data && typeof data === "object") {
    return data as Record<string, unknown>;
  }
  return undefined;
}

/** Detecta 403 por scopes insuficientes ou chamada à API legada fitness.googleapis.com. */
export function isGoogleHealthScopeError(error: unknown): boolean {
  if (!axios.isAxiosError(error) || error.response?.status !== 403) {
    return false;
  }

  const payload = getErrorPayload(error);
  const googleError = payload?.error as Record<string, unknown> | undefined;
  const message = String(googleError?.message ?? "");
  const details = Array.isArray(googleError?.details) ? googleError.details : [];
  const firstDetail = (details[0] ?? {}) as Record<string, unknown>;
  const reason = String(firstDetail.reason ?? "");
  const metadata = (firstDetail.metadata ?? {}) as Record<string, unknown>;
  const service = String(metadata.service ?? "");
  const method = String(metadata.method ?? "");

  return (
    reason === "ACCESS_TOKEN_SCOPE_INSUFFICIENT" ||
    message.toLowerCase().includes("insufficient authentication scopes") ||
    message.toLowerCase().includes("insufficient permission") ||
    service === "fitness.googleapis.com" ||
    method.includes("FitnessService.Aggregate")
  );
}

export function toGoogleHealthScopeError(error: unknown): GoogleHealthScopeError {
  return new GoogleHealthScopeError(
    GOOGLE_HEALTH_SCOPE_RECONNECT_MESSAGE,
    getErrorPayload(error)
  );
}

export function clearGoogleHealthcareAccessToken(): void {
  localStorage.removeItem("googleHealthcareAccessToken");
}
